import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ParseStep from "./ParseStep";
import SimilarStep from "./SimilarStep";
import UploadStep from "./UploadStep";
import SpecTemplatePanel from "./SpecTemplatePanel";

const SUBTABS = [
  { step: 1, label: "Documents" },
  { step: 2, label: "AI Parsing" },
  { step: 3, label: "Gap Detection" },
  { step: 4, label: "Similar Projects" },
  { step: 6, label: "Spec Template" },
  { step: 5, label: "Finalize" },
];

export default function IntakePanel({ projectId, pack, initialSpecs, onFinalized }) {
  const [step, setStep] = useState(1);
  const [specs, setSpecs] = useState(initialSpecs || {});
  const [parseResults, setParseResults] = useState(null);
  const [searchParams] = useSearchParams();
  // the pre-issue self-check and the validation fix guide link straight to the field they
  // want changed: ?tab=intake&focus=transport_height_mm
  const focus = searchParams.get("focus") || "";
  // the linking dialog can carry the value it recommends: &suggest=4800&why=GA-003%20clash
  const suggest = searchParams.get("suggest") || "";
  const suggestWhy = searchParams.get("why") || "";

  useEffect(() => { setSpecs(initialSpecs || {}); }, [projectId]); // eslint-disable-line
  useEffect(() => { if (focus) setStep(2); }, [focus]);

  const pill = (active) => `px-3 py-1.5 rounded-sm border text-[11px] transition-colors duration-150 ${
    active ? "border-[var(--c-accent)] bg-[var(--c-accent)]/15 text-[var(--c-text)]" : "border-[var(--c-border)] text-[var(--c-muted)] hover:text-[var(--c-text)]"}`;

  return (
    <div data-testid="intake-panel">
      <div className="flex items-center gap-1.5 flex-wrap mb-4" data-testid="intake-subtabs">
        {SUBTABS.map((s) => (
          <button key={s.step} data-testid={`intake-subtab-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => setStep(s.step)} className={pill(step === s.step)}>
            {s.label}
          </button>
        ))}
      </div>

      {step === 1 && (
        <>
          <UploadStep projectId={projectId} />
          <div className="flex justify-end mt-4">
            <button data-testid="intake-to-parse" onClick={() => setStep(2)}
              className="px-4 py-2 bg-[var(--c-accent)] hover:bg-[var(--c-accent-hover)] text-white text-xs rounded-sm transition-colors duration-150">
              Continue to AI Parsing →
            </button>
          </div>
        </>
      )}
      {(step === 2 || step === 3) && (
        <ParseStep step={step} setStep={setStep} projectId={projectId} pack={pack} focus={focus}
          suggest={suggest} suggestWhy={suggestWhy}
          specs={specs} setSpecs={setSpecs} parseResults={parseResults} setParseResults={setParseResults} />
      )}
      {step === 6 && (
        <SpecTemplatePanel projectId={projectId} onApplied={() => setStep(2)} />
      )}
      {(step === 4 || step === 5) && (
        <SimilarStep step={step} setStep={setStep} projectId={projectId} pack={pack} specs={specs}
          onFinalized={(id) => { onFinalized?.(id); setStep(1); }} />
      )}
    </div>
  );
}
